import "regenerator-runtime/runtime";
import "svgxuse";
import autoComplete from "@tarekraafat/autocomplete.js/dist/js/autoComplete";
import Alpine from "alpinejs";
import { instanciateTemplate } from "../app_js/framework/utils";
import "./../app_js/framework/components/horizontal-scroll-wrapper.js";
import { initCompanyTraineeRegistration } from "./company_trainee_registration.js";
import { initLearnerCountBounds } from "./learner_count_bounds.js";
import { initProgramSessionsCalendar } from "./program_sessions_calendar.js";
import { initLivePrice } from "./live_price.js";

/* global PROGRAMS */

window.Alpine = Alpine;

initCompanyTraineeRegistration(Alpine);

Alpine.start();

let hCaptchas = {}; // Stores the hCaptchas

if (!Int32Array.prototype.fill) {
  Int32Array.prototype.fill = Array.prototype.fill;
}

document.addEventListener("DOMContentLoaded", function () {
  const searchInput = () => document.querySelector("#search-input");

  if (searchInput()) {
    new autoComplete({
      data: {
        src: PROGRAMS,
        key: ["name"],
        cache: true,
      },
      selector: searchInput,
      placeHolder: "",
      threshold: 0,
      debounce: 300,
      highlight: true,
      maxResults: 10,
      searchEngine: "strict",
      resultsList: {
        render: true,
        container: (source) => {
          source.setAttribute("id", "search-results");
          source.setAttribute("class", "search-results");
        },
        destination: document.querySelector("#search .js-no-results"),
        position: "afterend",
        element: "ul",
      },
      resultItem: {
        content(data, source) {
          const {
            value: { category_order, category_slug, id, slug, subtitle },
            match,
          } = data;

          const href = `/${category_order}/${category_slug}/${id}/${slug}`;

          instanciateTemplate("#search-result-template", source, (instance) => {
            instance.querySelector(".js-program-button").href = href;
            instance.querySelector(".js-program-link").href = href;

            // innerHTML tolerated ONLY because we proactively escape the data in
            // CatalogHTML.programs_to_structs/1
            instance.querySelector(".js-program-link").innerHTML = match;

            if (subtitle) {
              // innerHTML tolerated ONLY because we proactively escape the data in
              // CatalogHTML.programs_to_structs/1
              instance.querySelector(".js-program-subtitle").innerHTML = subtitle;
            } else {
              instance.querySelector(".js-program-subtitle").remove();
            }
          });
        },
      },
    });

    document.addEventListener(
      "autoComplete",
      (event) => {
        const search = document.querySelector("#search");
        const main = document.querySelector("main");
        const noResults = search.querySelector(".js-no-results");

        if (event.detail.query.length) {
          main.classList.add("has-hidden");
          search.classList.add("has-contents");
        } else {
          search.classList.remove("has-contents");
          main.classList.remove("has-hidden");
        }

        if (event.detail.matches > 0) {
          noResults.classList.add("has-hidden");
        } else {
          noResults.classList.remove("has-hidden");
        }
      },
      false
    );
  }

  const registrationTypesBtn = document.querySelectorAll(".js-registration-type-btn");

  if (registrationTypesBtn.length == 2) {
    const interBtn = document.querySelector("#js-registration-type-inter");
    const intraBtn = document.querySelector("#js-registration-type-intra");
    interBtn.addEventListener("click", function () {
      const dateComponents = document.querySelectorAll(".js-registration-date");
      for (let dateComponent of dateComponents) {
        dateComponent.querySelector("select").disabled = false;
        dateComponent.classList.remove("has-hidden");
      }
      document.dispatchEvent(new CustomEvent("registrationTypeChanged", { detail: { type: "inter" } }));
    });
    intraBtn.addEventListener("click", function () {
      const dateComponents = document.querySelectorAll(".js-registration-date");
      for (let dateComponent of dateComponents) {
        dateComponent.querySelector("select").disabled = true;
        dateComponent.classList.add("has-hidden");
      }
      document.dispatchEvent(new CustomEvent("registrationTypeChanged", { detail: { type: "intra" } }));
    });
  }

  const traineeForm = document.querySelector("#trainee-form");
  const companyForm = document.querySelector("#company-form");
  const forms = [traineeForm, companyForm];

  forms.forEach(setupValidation);
  forms.forEach(bindSubmitButton);

  createHCaptchas();

  initLearnerCountBounds();
  initLivePrice();

  const programs = document.querySelectorAll(".js-program");
  const trainingPedagogicalModalityFilter = document.querySelector("#training-pedagogical-modality-filter");
  const certifyingFilter = document.querySelector("#certifying-filter");
  const cpfOrFundingFilter = document.querySelector("#js-cpf-or-funding-filter");
  const cityFilter = document.querySelector("#js-city-filter");

  const programsFilter = () => {
    const selectedModality = trainingPedagogicalModalityFilter ? trainingPedagogicalModalityFilter.value : "any";
    const selectedCity = cityFilter ? cityFilter.value : "any";
    const selectedCertifying = certifyingFilter ? certifyingFilter.value : "any";
    // international catalog don't have cpf or funding field
    const selectedCpfOrFunding = cpfOrFundingFilter ? cpfOrFundingFilter.value : "any";
    programs.forEach((program) => {
      const modality = program.dataset.trainingPedagogicalModality;
      const certifying = program.dataset.certifying != undefined;
      const cpfOrFunding = program.dataset.cpf != undefined || program.dataset.funding != undefined;
      const city = program.dataset.city;

      if (
        (selectedModality === "any" || selectedModality == modality.toString()) &&
        (selectedCertifying === "any" || selectedCertifying == certifying.toString()) &&
        (selectedCpfOrFunding === "any" || selectedCpfOrFunding == cpfOrFunding.toString()) &&
        (selectedCity === "any" || selectedCity == city)
      ) {
        program.classList.remove("has-hidden");
      } else {
        program.classList.add("has-hidden");
      }
    });
  };

  if (trainingPedagogicalModalityFilter) {
    trainingPedagogicalModalityFilter.addEventListener("change", () => programsFilter());
  }

  if (certifyingFilter) {
    certifyingFilter.addEventListener("change", () => programsFilter());
  }

  if (cpfOrFundingFilter) {
    cpfOrFundingFilter.addEventListener("change", () => programsFilter());
  }

  if (cityFilter) {
    cityFilter.addEventListener("change", () => programsFilter());
  }

  programsFilter();

  initProgramSessionsCalendar();
});

function createHCaptchas() {
  if (!window.hcaptcha) {
    setTimeout(createHCaptchas, 500);
  } else {
    document.querySelectorAll(".js-h-captcha-spot").forEach(function (div) {
      const siteKey = div.getAttribute("data-sitekey");
      const callback = div.getAttribute("data-callback");
      const size = div.getAttribute("data-size");
      const formId = div.getAttribute("data-form-id");

      let widgetID = window.hcaptcha.render(`hcaptcha-${formId}`, { sitekey: siteKey, callback: callback, size: size });
      hCaptchas[formId] = widgetID;
    });
  }
}

function bindSubmitButton(form) {
  if (!form) {
    return;
  }

  const button = form.querySelector("button[type='submit']");

  button.addEventListener(
    "click",
    (event) => {
      event.preventDefault();
      validateForm(form);

      let hCaptchaWidgetID = hCaptchas[form.id];
      // IE does not support this API, in this case directly call hcaptcha
      if (form.reportValidity) {
        if (form.reportValidity()) {
          window.hcaptcha.execute(hCaptchaWidgetID);
        }
      } else {
        window.hcaptcha.execute(hCaptchaWidgetID);
      }
    },
    false
  );
}

function validateForm(form) {
  const inputs = form.getElementsByTagName("input");
  const textareaInputs = form.getElementsByTagName("textarea");

  trimFormFields(inputs, textareaInputs); // So that a field filled with spaces is not considered valid if required
  invalidateInvalidDates(inputs); // A date with a year over 9999 produces an invalid changeset in backend
}

function trimFormFields(inputs, textareaInputs) {
  for (const input of inputs) {
    if (input.type !== "hidden") {
      input.value = input.value.trim();
    }
  }

  for (const textarea of textareaInputs) {
    textarea.value = textarea.value.trim();
  }
}

function invalidateInvalidDates(inputs) {
  for (const input of inputs) {
    if (input.type === "date") {
      const year = input.value.split("-")[0];
      if (year.length > 4) {
        input.setCustomValidity("L'année est trop grande");
      } else {
        input.setCustomValidity("");
      }
    }
  }
}

function setupValidation(form) {
  if (!form) {
    return;
  }

  const inputs = form.querySelectorAll("input, select, textarea");

  for (let input of inputs) {
    input.addEventListener(
      "invalid",
      () => {
        input.classList.add("error");
      },
      false
    );

    input.addEventListener("blur", () => {
      input.checkValidity();
    });
  }
}

const submit = (selector) => {
  const form = document.querySelector(selector);
  return form.submit();
};

window.onRegistrationCompanySubmit = () => submit("#company-form");
window.onRegistrationTraineeSubmit = () => submit("#trainee-form");
